import React from "react"

import { render, astify } from "~utils/rehype-render"
import Parameters, { Wrapper, Variants } from "~components/Parameters"
import ResponseExample from "~components/ResponseExample"

import { TwoColumnContent } from "~layouts/ReferenceLayout"
import { withMicrocopy } from "~contexts/MicrocopyContext"
import { style, Navigation } from "~components/Endpoint"
import TooltipWrapper from "~components/TooltipWrapper"
import Message from "~components/Message"
import VersionDropdown from "./ApiVersioning/VersionDropdown"
import { isBaseVersion } from '../utils/versioning'

const Resource = ({ resource, microcopy }) => (
  <div className={style.reference}>
    <TwoColumnContent>
      <>
        <h1>{resource.title}</h1>
        <TooltipWrapper
          content={microcopy.text("versions.resource_version_tooltip").replace("%s", resource.version)}
        >
          <VersionDropdown
            microcopy={microcopy}
            version={resource.version}
            versions={[resource.version]}
          />
        </TooltipWrapper>
        <Navigation item={resource} microcopy={microcopy} hideInPageNav />
        {isBaseVersion(resource.version) && (
          <Message
            type="notice"
          >
            {render(astify(microcopy.text("versions.base_version_notice.__raw__.resource")))}
          </Message>
        )}
        <div className={style.summary}>{render(resource.descriptionAst)}</div>
        <Wrapper>
          {resource.hasVariants && <Variants hideExtras resource={resource} />}
          <Parameters hideExtras params={resource.params} />
        </Wrapper>
      </>
      <>
        {
          resource.jsonExample && (
            <div className={style.examples}>
              <ResponseExample code={resource.jsonExample} />
            </div>
          )
        }
      </>
    </TwoColumnContent>
  </div>
)

export default withMicrocopy(Resource)
